import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, LoginGuard, RailMyBoxRoles, routeGuard } from '@railmybox/auth';
import { AccessDeniedComponent } from '@railmybox/layout';
import { ComponentsComponent } from './components/components.component';
import { CAPACITY_MANAGEMENT_QUICK_FILTERS_STORE_NAME, CAPACITY_MANAGEMENT_STORE_NAME } from '@railmybox/shared/store-services';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  { path: 'access-denied', component: AccessDeniedComponent, canActivate: [AuthGuard] },
  {
    path: 'auth',
    loadChildren: () => import('@railmybox/auth').then((module) => module.AuthModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'booking',
    loadChildren: () => import('@railmybox/booking').then((module) => module.BookingModule),
    canActivate: [AuthGuard, routeGuard],
    data: { roles: [RailMyBoxRoles.CUSTOMER, RailMyBoxRoles.TYPIST] },
  },
  {
    path: 'profile',
    loadChildren: () => import('@railmybox/profile').then((module) => module.ProfileModule),
    canActivate: [AuthGuard, routeGuard],
    data: { roles: [RailMyBoxRoles.CUSTOMER] },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('@railmybox/dashboard').then((module) => module.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'support',
    loadChildren: () => import('@railmybox/support').then((module) => module.SupportModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'wishlist',
    loadChildren: () => import('@railmybox/wishlist').then((module) => module.WishlistModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'capacity-management',
    loadChildren: () => import('@railmybox/capacity-manager').then((module) => module.CapacityManagementModule),
    canActivate: [AuthGuard],
    providers: [
      { provide: CAPACITY_MANAGEMENT_STORE_NAME, useValue: 'main-capacity-management' },
      { provide: CAPACITY_MANAGEMENT_QUICK_FILTERS_STORE_NAME, useValue: 'main-quick-filters' },
    ],
  },
  {
    path: 'components',
    component: ComponentsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot([...routes])],
  exports: [RouterModule],
})
export class AppRoutingModule {}
